export default __webpack_public_path__ + "css/sideMenu.bundle.css";